import React from "react";

// Símbolos comunes para descripciones de material (mecanizado).
// Reutilizable en /compras (NuevaOCForm) y /catálogo (MaterialPicker).
export const SIMBOLOS_MATERIAL = [
  { sym: "Ø",   title: "Diámetro" },
  { sym: "□",   title: "Cuadrado / barra cuadrada" },
  { sym: "▭",   title: "Plana / planchuela" },
  { sym: "▢",   title: "Tubo cuadrado / hueco" },
  { sym: "◯",   title: "Redondo" },
  { sym: "⊕",   title: "Perforado" },
  { sym: "×",   title: "Por (dimensiones, ej. 200×200)" },
  { sym: "°",   title: "Grados" },
  { sym: "⌀",   title: "Diámetro alt." },
  { sym: "½",   title: "1/2 (fracción pulgada)" },
  { sym: "¼",   title: "1/4" },
  { sym: "⅛",   title: "1/8" },
  { sym: "ø",   title: "Diámetro minúscula (alt)" },
  { sym: "²",   title: "al cuadrado (m²)" },
  { sym: "³",   title: "al cubo (m³)" },
];

const SimbolosToolbar = ({ onInsert, targetLabel, compact }) => (
  <div style={{
    background: "#0d0d0d",
    padding: compact ? "4px 8px" : "6px 10px",
    border: "1px solid #2e2e2e",
    borderRadius: compact ? 4 : 0,
    display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap",
    marginBottom: compact ? 4 : 0,
  }}>
    <span style={{
      fontSize: 9, fontWeight: 700, color: "#aaa",
      textTransform: "uppercase", letterSpacing: ".06em",
    }}>Símbolos:</span>
    {SIMBOLOS_MATERIAL.map(s => (
      <button
        key={s.sym}
        type="button"
        onClick={() => onInsert(s.sym)}
        title={s.title + " — click para insertar en la descripción enfocada"}
        style={{
          background: "#1a1a1a", border: "1px solid #2e2e2e",
          color: "#ddd", borderRadius: 4,
          padding: compact ? "2px 7px" : "3px 9px",
          fontSize: 13, cursor: "pointer",
          fontFamily: "Arial, sans-serif", lineHeight: 1,
        }}
      >{s.sym}</button>
    ))}
    {targetLabel && (
      <>
        <span style={{ flex: 1 }} />
        <span style={{ fontSize: 9, color: "#999", fontStyle: "italic" }}>
          → {targetLabel}
        </span>
      </>
    )}
  </div>
);

export default SimbolosToolbar;
